import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={2}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Comercial
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Artesco & TNO Network
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 3 }}
        >
          El Arte de Plasmar tu Fe: Aliado de Bienestar en Punto de Fe
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            component="img"
            src="/images/logos/artesco.webp"
            alt="Artesco"
            sx={{
              width: 120,
              height: 120,
              objectFit: 'contain',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Box>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>Análisis de Oportunidad</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            La fe no solo se siente, se cultiva. Proponemos que <strong>Artesco</strong> deje de ser un proveedor de útiles para convertirse en el <strong>facilitador de la introspección</strong>. En un mundo digital, el acto de escribir a mano es un acto de presencia. Con Margarita Toledo en <strong>Punto de Fe</strong>, transformaremos los productos de Artesco en herramientas de sanación y crecimiento espiritual.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
